import { render, staticRenderFns } from "./FarmMenuItem.vue?vue&type=template&id=62c52bc6&scoped=true"
import script from "./FarmMenuItem.vue?vue&type=script&lang=ts"
export * from "./FarmMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./FarmMenuItem.vue?vue&type=style&index=0&id=62c52bc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c52bc6",
  null
  
)

export default component.exports